/**
 * Case-insensitive substring match across stringifiable field values.
 * Empty/whitespace search matches everything.
 */
export function filterByClientSearch<T>(
  items: T[],
  search: string,
  pick: (item: T) => unknown[],
): T[] {
  const q = search.trim().toLowerCase();
  if (!q) return items;
  return items.filter((item) =>
    pick(item).some((value) => value != null && String(value).toLowerCase().includes(q)),
  );
}
